import { defineStore } from "pinia"
import { fetchDashboardData, showNextOfKin } from "@/api/dashboard"
import { fetchProductData } from "@/api/product"

export const useDashStore = defineStore("dashboard", {
    state: () => ({
        user: null,
        products: [],
        nok: null
    }),

    actions: {
        async loadUser() {
            const res = await fetchDashboardData()
            //this.user = res.data.data
            this.user = res.data.data.dashboard_data
        },
        async loadProduct() {
            const res = await fetchProductData()
            this.products = res.data.data
        },
        async loadNok(userId) {
            try{
                const res = await showNextOfKin(userId)
                this.nok = res.data.data[0] || ''
            } catch (error) {
                console.error("Failed to load Nok:", error)
                this.nok = null
            }
        }
    }
})